import { useTranslation } from 'react-i18next';
import { useEffectOnce } from 'react-use';
import { TimesIcon } from '@c2fo/liquidity/icons';
import useDataDog from '@/reporting/DataDog';

const HolidayDelayBanner = ({ onDismiss }: { onDismiss: () => void }) => {
  const { t } = useTranslation();
  const { addAction } = useDataDog();

  useEffectOnce(() => {
    addAction('enterprise::holiday-delay-banner::shown', {
      message: `Holiday delay notice banner shown`,
    });
  });

  return (
    <div className="h-10 w-full bg-yellow-200 px-4 py-2 sm:py-0">
      <div className="flex h-full flex-row items-center justify-between md:justify-center">
        <p className="flex-1 text-center text-xs sm:text-left sm:text-sm md:text-center md:text-base">
          Payments by US financial institutions are suspended on <strong>Jul. 3, 2026</strong> for the federal holiday.
        </p>
        <button
          aria-label={t('core.close')}
          className="z-20 ml-4 p-1 text-xl transition-all duration-200 hover:bg-black/10"
          type="button"
          onClick={onDismiss}
        >
          <TimesIcon className="h-7 w-7 fill-text-primary" />
        </button>
      </div>
    </div>
  );
};

export default HolidayDelayBanner;
